'use strict';

var React = require('react');
var ReactDOM = require('react-dom');
var reactUtils = require('@sravni/react-utils');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);
var ReactDOM__namespace = /*#__PURE__*/_interopNamespaceDefault(ReactDOM);

let portalContainer = null;
const portalAttribute = 'sr-portal-container';
const Portal = React__namespace.memo((props) => {
    const { children } = props;
    const portal = React__namespace.useMemo(() => {
        if (!reactUtils.isBrowser) {
            return null;
        }
        if (portalContainer) {
            return portalContainer;
        }
        const el = document.querySelector(`div[${portalAttribute}]`);
        if (el) {
            portalContainer = el;
            return portalContainer;
        }
        portalContainer = document.createElement('div');
        portalContainer.setAttribute(portalAttribute, '');
        document.body.appendChild(portalContainer);
        return portalContainer;
    }, []);
    if (!reactUtils.isBrowser) {
        return null;
    }
    if (portal) {
        return ReactDOM__namespace.createPortal(children, portal);
    }
    return null;
});
Portal.displayName = 'Portal';

exports.Portal = Portal;
//# sourceMappingURL=Portal.js.map
